<hrb-nav-secondary stacked="true">
  <hrb-nav-secondary-item
    *ngFor="let link of tocLinks; index as i"
    [attr.link-text]="link.label"
    [attr.is-current]="currentTocLink === link.id"
    (click)="scrollTo($event)">
  </hrb-nav-secondary-item>
</hrb-nav-secondary>